import React, { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';
import { Moon, Sun, PenOff , Pen } from 'lucide-react';
import TopNavBar from '../components/TopNavbar';
import FullscreenWrapper from '../components/FullscreenWrapper';
import Assets from '../components/Assets/Assets';
import Settings from '../components/Settings/Settings';
import { useAuth } from '../context/AuthContext';
import { PERMISSIONS } from '../utils/constants';

function Dashboard() {
  const { theme, toggleTheme } = useTheme();
  const { permissions, currentSiteId } = useAuth();
  const [currentSelection, setCurrentSelection] = useState("");
  const [editEnabled, setEditEnabled] = useState(false);

  useEffect(() => {
    // Reset state when site changes
    //setCurrentSelection("settings");
    setEditEnabled(false);
  }, [currentSiteId]);

  const handleNavigate = (selection) => {
    setCurrentSelection(selection);
  };

  const toggleEdit = () => {
    setEditEnabled(!editEnabled);
  };

  return (
    <div className={`w-full ${theme === 'light' ? 'bg-white text-gray-900' : 'bg-gray-900 text-white'}`}>
      <FullscreenWrapper>
        <TopNavBar onNavigate={handleNavigate} currentSelection={currentSelection} />
        {currentSelection === "assets" && <Assets editEnabled={editEnabled} />}
        {currentSelection === "settings" && <Settings editEnabled={editEnabled} />}
        
        <div className="fixed bottom-14 md:left-3 left-0 flex flex-col gap-2">
          {permissions.includes(PERMISSIONS.GLOBAL.GLOBAL_EDIT) && (
            <button
              onClick={toggleEdit}
              className={`hidden md:block p-2 rounded-full ${
                theme === 'light' 
                  ? 'bg-gray-200 hover:bg-gray-300' 
                  : 'bg-gray-700 hover:bg-gray-600'
                } transition-colors duration-200 ${editEnabled ? 'text-blue-500' : ''}`}
              title={`${editEnabled ? 'Disable' : 'Enable'} edit mode`}
            >
              {editEnabled ? (
                <Pen className="h-4 w-4" />
              ) : (
                <PenOff className="h-4 w-4" />
              )}
            </button>
          )}
          <button
            onClick={toggleTheme}
            className={`p-2 md:rounded-full rounded-r-full ${
              theme === 'light' 
                ? 'bg-gray-200 hover:bg-gray-300' 
                : 'bg-gray-700 hover:bg-gray-600'
              } transition-colors duration-200`}
            title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
          >
            {theme === 'light' ? (
              <Moon className="h-4 w-4" />
            ) : (
              <Sun className="h-4 w-4" />
            )}
          </button>
        </div>
      </FullscreenWrapper>
    </div>
  );
}

export default Dashboard;